<template>
  <div>
    <!-- 配送单待报价 -->
    <baseBreadcrumb
      :page="$t('message.deliveryOrderToBeQuoted')"
      :menu="$t('message.porder')"
    />

    <porderBaseTable :status="22" />
  </div>
</template>
<script>
import porderBaseTable from "@/components/porder/porderBaseTable/index";
export default {
  components: { porderBaseTable },
  data() {
    return {};
  },
  methods: {},
};
</script>
<style lang='scss' scoped>
</style>